
/**
 * 通用数据上报工具
**/

class AnalyticsReporter {
    constructor(options = {}) {

        //暂时无用，后续扩展
        // this.options = {
        //     ...options
        // };
        
        this.queue = [];
    }

    // 检查requestIdleCallback支持
    supportsIdleCallback() {
        return 'requestIdleCallback' in window;
    }

    // 兼容性空闲回调
    requestIdleCallback(callback, options = {}) {
        if (this.supportsIdleCallback()) {
            return window.requestIdleCallback(callback, options);
        } else {
            let start = Date.now();
            return setTimeout(function () {
                const deadline = { // 这边就是为了构造参数
                    timeRemaining: () => Math.max(0, 50 - (Date.now() - start)), // 剩余时间我们写死在 50ms 内，也就是前面提到的上限值，其实你也可以写成 40、30、16、10 等😂
                    didTimeout: false // 因为我们不推荐使用 timeout 参数，所以这里就直接写死 false
                };
                callback(deadline);
            });
        }
    }

    // 取消空闲回调
    cancelIdleCallback(handle) {
        if (this.supportsIdleCallback()) {
            window.cancelIdleCallback(handle);
        } else {
            clearTimeout(handle);
        }
    }

    /**
     * 上报数据
     * @param {Object} data 要上报的数据
     */
    report(data = {}) {
        this.queue.push(data); 
        // 在空闲时上报
        this.requestIdleCallback((deadline) => {
            this.processQueue(deadline);
        });
    }

    /**
     * 批量处理队列中的数据
     */
    processQueue(deadline) {
        if (this.queue.length === 0) {
            return;
        }

        while (deadline.timeRemaining() > 0 && this.queue.length > 0) {
            const data = this.queue.shift();
            window.gtag && gtag('event', 'click_manual', data); 
        }

        if (this.queue.length > 0) {
            this.requestIdleCallback((deadline) => {
                this.processQueue(deadline);
            });
        }
    }
}

window.GAReporter = new AnalyticsReporter();